export const PAID = 'PAID'
export const NOT_PAID = 'NOT_PAID'
